import { t } from 'i18next';
import { Outlet, RouteObject } from 'react-router-dom';
import { SubstitutionProvider } from '../../components/Substitutions/SubstitutionProvider';
import { SubstitutionsEvaluatePage } from './Evaluate/SubstitutionsEvaluatePage';
import { substitutionPlanRoutes } from './Plan/routes';
import { substitutionSetupRoutes } from './Setup/routes';
import { SubstitutionsPage } from './SubstitutionsPage';

export const substitutionsRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <SubstitutionsPage />,
    },
    {
      path: t('routes.setup.slug') + '/*',
      element: <Outlet />,
      children: [...substitutionSetupRoutes(`${baseSlug}/${t('routes.setup.slug')}`)],
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.setup.slug')}`,
          title: t('routes.setup.title'),
        }),
      },
    },
    {
      path: t('routes.plan.slug') + '/*',
      element: (
        <SubstitutionProvider>
          <Outlet />
        </SubstitutionProvider>
      ),
      children: [...substitutionPlanRoutes(`${baseSlug}/${t('routes.plan.slug')}`)],
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.plan.slug')}`,
          title: t('routes.plan.title'),
        }),
      },
    },
    {
      path: t('routes.evaluate.slug'),
      element: <SubstitutionsEvaluatePage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.evaluate.slug')}`,
          title: t('routes.evaluate.title'),
        }),
      },
    },
  ];
};
